import type { DesignTypeCategories } from "@nlc/shared-types";

import { RequestTypeEnum } from "@nlc/shared-types";
import { SettingsIcon } from "lucide-react";

import { useRoleAccess } from "@/features/auth/permissions/useRoleAccess.tsx";
import { useTemplateLock } from "@/features/request/edit/hooks/useTemplateLock.tsx";
import { useGetRequest } from "@/hooks/useGetRequest.tsx";

import { CollapsibleBox } from "../CollapsibleBox";
import { LinkedRequestsSelect } from "./LinkedRequestsSelect";
import { SelectRequestType } from "./SelectRequestType";

const REQUEST_TYPE_TO_DESIGN_CATEGORY: Partial<
  Record<RequestTypeEnum, DesignTypeCategories>
> = {
  [RequestTypeEnum.GRAPHIC]: "graphic",
  [RequestTypeEnum.VIDEO]: "video",
  [RequestTypeEnum.WEBSITE_DESIGN]: "webui",
};

export function RequestDetailsSection() {
  const { data: request } = useGetRequest();
  const { canAccess } = useRoleAccess();
  const { isLocked } = useTemplateLock();

  if (!request) return null;

  const isReadOnly =
    canAccess("edit-request.details.designer.view") || isLocked;
  const category =
    REQUEST_TYPE_TO_DESIGN_CATEGORY[request.requestType as RequestTypeEnum];

  return (
    <CollapsibleBox
      icon={<SettingsIcon className="text-white" size={16} />}
      iconClassName="bg-fg-brand-primary"
      title="Request details"
    >
      {category && (
        <SelectRequestType category={category} isDisabled={isReadOnly} />
      )}
      <LinkedRequestsSelect isDisabled={isReadOnly} />
    </CollapsibleBox>
  );
}
